import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=bce8a040&scoped=true&"
import script from "./Sections.vue?vue&type=script&lang=js&"
export * from "./Sections.vue?vue&type=script&lang=js&"
import style0 from "./Sections.vue?vue&type=style&index=0&id=bce8a040&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce8a040",
  null
  
)

export default component.exports